import { SyncExternalStore } from '@egr/xbox/utils/SyncExternalStore';

interface FullscreenState {
    fullScreen: boolean;
}

class FullscreenViewerStore extends SyncExternalStore<FullscreenState> {
    constructor() {
        super({
            fullScreen: false,
        });
        document.addEventListener('fullscreenchange', () => {
            const isActive = document.fullscreenElement ? true : false;
            this.updateState({ fullScreen: isActive });
        });
    }
}

export const fullscreenViewerStore = new FullscreenViewerStore();
